<div class="medium-content">
  <h1>Page not found</h1>
  <p>You might have mistyped the URL.</p>
  <p>
    Go back to the
    <a routerLink="/" class="text-link">home page.</a>
  </p>
</div>
